module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-main-image-pc-d62306b481120f6ada80177f096e6ee3.png";